import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ImpressumPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <button onClick={() => navigate(-1)} data-testid="impressum-back-btn" className="flex items-center gap-2 text-sm text-[#4B5563] hover:text-[#0A0A0A] mb-8">
          <ArrowLeft size={16} /> Zurück
        </button>
        <h1 className="text-3xl font-bold text-[#0A0A0A] mb-8">Impressum</h1>
        <div className="prose prose-gray max-w-none space-y-6 text-[#4B5563] leading-relaxed">
          <h2 className="text-xl font-bold text-[#0A0A0A]">Angaben gemäß § 5 DDG</h2>
          <p>
            P1 Performance Center GmbH<br />
            Georg-Stieß-Straße 2<br />
            75181 Pforzheim<br />
            Deutschland
          </p>
          <p className="text-sm">
            Sitz der Gesellschaft: 75181 Pforzheim (Hauptstraße 26)
          </p>
          <h2 className="text-xl font-bold text-[#0A0A0A]">Vertreten durch</h2>
          <p>Geschäftsführer: Phi Philip Nguyen</p>
          <h2 className="text-xl font-bold text-[#0A0A0A]">Registereintrag</h2>
          <p>
            Eintragung im Handelsregister<br />
            Registergericht: Amtsgericht Mannheim<br />
            Registernummer: HRB 752951
          </p>
          <h2 className="text-xl font-bold text-[#0A0A0A]">Kontakt</h2>
          <p>
            Telefon: 0176 86477728<br />
            E-Mail: info@p1-pforzheim.de
          </p>
          <h2 className="text-xl font-bold text-[#0A0A0A]">Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE452272513
          </p>
          <h2 className="text-xl font-bold text-[#0A0A0A]">Bankverbindung</h2>
          <p>
            Sparkasse Pforzheim-Calw<br />
            IBAN: DE22 6665 0085 0005 6840 99<br />
            BIC: PZHSDE66XXX
          </p>
          <h2 className="text-xl font-bold text-[#0A0A0A]">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>
            Phi Philip Nguyen<br />
            Georg-Stieß-Straße 2, 75181 Pforzheim
          </p>
          {/* Der Verweis auf die EU-Plattform zur Online-Streitbeilegung ist
              entfallen: Die Plattform wurde am 20.07.2025 abgeschaltet, die
              Pflicht zur Verlinkung ist mit ihr weggefallen. Ein Link auf eine
              tote Seite ist irreführend. Die Erklärung nach § 36 VSBG bleibt. */}
          <h2 className="text-xl font-bold text-[#0A0A0A]">Verbraucherstreitbeilegung</h2>
          <p>
            Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen (§ 36 Verbraucherstreitbeilegungsgesetz).
            Bei Anliegen wenden Sie sich bitte direkt an uns — die Kontaktdaten stehen oben.
          </p>
        </div>
      </div>
    </div>
  );
}
